import { useFormaliteService } from '@europrocurement/l2d-domain';
import { DossierOpenSearchJsonldOpensearchDossierContactRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierContact = DossierOpenSearchJsonldOpensearchDossierContactRead &
    Record<string, unknown>;

const useDossierContact = () => {
    const { dossierOpenSearchApi } = useFormaliteService();
    let searchTimeout: number | undefined;

    const searchDossierContact = (term: string): Promise<Array<DossierContact>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchTimeout);
            const requestParameters = { q: term || undefined };

            searchTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchContactsGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<DossierContact>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchDossierContact };
};

export default useDossierContact;
